/*global process*/
import React from "react";

export default function ECLDynamicMap() {
   if (process.env.BUILD !== "production") {
      return <>Dynamic Map Currently Unavailable</>;
   } else {
      return <p>Dynamic Map Unavailable</p>;
   }
}
